import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import BeefBracketVoteCard from './BeefBracketVoteCard';
import BeefBracketVoteForm from './BeefBracketVoteForm';
import Loader from '../Utility/Loader.js';
import { AJAX_URL } from '../../config/index.js';
import { set } from 'lodash';

export default function BeefBracketApp() {
  const [contenderOne, setContenderOne] = useState({});
  const [contenderTwo, setContenderTwo] = useState({});
  const [view, setView] = useState('contender-screen');
  const [showNotice, setShowNotice] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [currentVote, setCurrentVote] = useState(null);
  const [slideOutCards, setSlideOutCards] = useState(false);
  const [slideInForm, setSlideInForm] = useState(false);
  const [slideOutForm, setSlideOutForm] = useState(false);
  const [slideInCards, setSlideInCards] = useState(false);
  const [footerChecked, setFooterChecked] = useState(false);

  const handleTransitionToVoteForm = () => {
    setSlideInForm(true);
    setTimeout(() => {
      setSlideOutCards(true);
    }, 100);
    setTimeout(() => {
      setView('vote-form');
    }, 300);
    setTimeout(() => {
      setSlideInForm(false);
      setSlideOutCards(false);
    }, 400);
    setTimeout(() => {
      setSlideOutCards(false);
      if (window.innerWidth < 770) {
        document.body.classList.remove('footer-fade-in');
        document.body.classList.remove('footer-higher-than-viewport');
      }
    }, 750);

    // Push to dataLayer for analytics
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'beef_bracket_vote_button_clicked',
      event_type: 'vote_button_clicked',
      timestamp: new Date().toISOString()
    });
  };

  const handleTransitionToContenderScreen = () => {
    setSlideInCards(true);
    setTimeout(() => {
      setSlideOutForm(true);
    }, 100);
    setTimeout(() => {
      setView('contender-screen');
    }, 300);
    setTimeout(() => {
      setSlideInCards(false);
      setCurrentVote(null);
    }, 400);
    setTimeout(() => {
      setSlideOutForm(false);
      setShowNotice(false);
      updateStickyFooter();
    }, 750);
  };

  // Trigger updateStickyFooter() if viewport height changes
  useEffect(() => {
    const handleResize = () => {
      updateStickyFooter();
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const updateStickyFooter = () => {
    const footer = document.querySelector('footer');
    if (footer) {
      const footerheightOnPage = footer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (footerheightOnPage.bottom <= viewportHeight) {
        document.body.classList.add('footer-higher-than-viewport');
      } else {
        document.body.classList.remove('footer-higher-than-viewport');
      }
      document.body.classList.add('footer-fade-in');
    }
  };

  useEffect(() => {
    setLoading(true);

    // Fetch contenders data on initial load
    $.ajax({
      type: 'POST',
      url: `${AJAX_URL}wl_get_beef_bracket_contenders`,
      dataType: 'json',
      encode: true,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
    })
      .then((res) => {
        if (
          !res.success &&
          res.data.message == 'No current Beef Bracket Poll found.'
        ) {
          // Redirect to Beef Bowl Tally page if no poll is found
          window.location.href = '/beef-bowl-tally';
          return;
        }

        setContenderOne(res.data.contender_one);
        setContenderTwo(res.data.contender_two);

        // Check if the bottom of the footer is higher than the viewport
        if (!footerChecked) {
          setTimeout(() => {
            updateStickyFooter();
          }, 250);
          setFooterChecked(true);
        }

        setLoading(false);
      })
      .catch((err) => console.log(err.message));
  }, []);

  return (
    <>
      <div
        className={`beef-bracket-app
          ${slideOutCards ? 'slide-out-cards' : ''}
          ${slideInForm ? 'slide-in-form' : ''}
          ${slideOutForm ? 'slide-out-form' : ''}
          ${slideInCards ? 'slide-in-cards' : ''}
        `}
      >
        <div className="beef-bracket-header">
          <div className="beef-bracket-mobile-logo">
            <div className="beef-bracket-vote-tally-vs-logo"></div>
          </div>
          <div className="beef-bracket-title">
            <h1 className="title">THE BEEF LOVING TEXANS BOWL</h1>
          </div>
          <div className="beef-bracket-subtitle">
            <div className="subtitle">
              <h2>THREE WEEKS</h2>
              <span className="star-icon"></span>
              <h2>FOUR DISHES</h2>
              <span className="star-icon"></span>
              <h2>ONE CHAMPION</h2>
            </div>
          </div>
        </div>
        {view === 'contender-screen' ? (
          <>
            {isLoading ? (
              <Loader />
            ) : (
              <>
                <div className="beef-bracket-vote-tally-container beef-bracket-app">
                  <div className="beef-bracket-vote-tally">
                    <BeefBracketVoteCard
                      view={view}
                      scoreObject={contenderOne}
                      setScoreObject={setContenderOne}
                      isLoading={isLoading}
                      setView={setView}
                      currentVote={currentVote}
                      setCurrentVote={setCurrentVote}
                      handleTransitionToVoteForm={handleTransitionToVoteForm}
                    />
                  </div>
                  <div className="beef-bracket-vote-tally-vs-column">
                    <div className="beef-bracket-vote-cast-text">
                      <span className="md">Vote</span>
                      <span className="sm">For Your</span>
                      <span className="lg">MVP</span>
                    </div>
                    <div className="beef-bracket-vote-tally-vs-icon">
                      <div className="beef-bracket-vote-tally-vs-icon-inner">
                        <span className="vs-icon">VS</span>
                      </div>
                    </div>
                    <div className="beef-bracket-vote-tally-vs-logo"></div>
                  </div>
                  <div className="beef-bracket-vote-tally">
                    <BeefBracketVoteCard
                      view={view}
                      scoreObject={contenderTwo}
                      setScoreObject={setContenderTwo}
                      isLoading={isLoading}
                      setView={setView}
                      currentVote={currentVote}
                      setCurrentVote={setCurrentVote}
                      handleTransitionToVoteForm={handleTransitionToVoteForm}
                    />
                  </div>
                </div>
                <div className="beef-bracket-vote-cast-text mobile">
                  <span className="md">Vote</span>
                  <span className="sm">For Your</span>
                  <span className="lg">MVP</span>
                </div>
              </>
            )}
          </>
        ) : (
          view === 'vote-form' && (
            <BeefBracketVoteForm
              isLoading={isLoading}
              setLoading={setLoading}
              setView={setView}
              setShowNotice={setShowNotice}
              currentVote={currentVote}
              handleTransitionToContenderScreen={
                handleTransitionToContenderScreen
              }
            />
          )
        )}
      </div>
    </>
  );
}
